import React from 'react';
import { Route } from 'react-router';

import { Participant } from './controllers';
import { getHomePath } from './util';

export default () => (
  <Route component={Participant} path={`${getHomePath()}take/:surveyToken(/:invitationToken)`} />
);
